import { Entry, Locale } from 'contentful';
import IFlatConnection from '@app/types/data/base/IFlatConnection';
import { TypeConnectionSkeleton } from '@/@types/generated/contentful';
import MultiLocaleService from './base/MultiLocaleService';

export default class ConnectionService extends MultiLocaleService {
	public async getFlatConnections(): Promise<Record<string, IFlatConnection[]>> {
		const connections = await this.deliveryClient.withAllLocales.getEntries<TypeConnectionSkeleton>({
			// eslint-disable-next-line @typescript-eslint/naming-convention
			content_type: 'connection',
			limit: 1000,
			include: 0
		});

		const connectionsByLocaleCode: Record<string, IFlatConnection[]> = {};

		this.locales.forEach((locale: Locale): void => {
			connectionsByLocaleCode[locale.code] = connections.items.map(
				(connectionEntry: Entry<any>): IFlatConnection => {
					const connection: IFlatConnection = {
						...this.mapToSingleLocaleObject(connectionEntry.fields, locale),
						id: connectionEntry.sys.id
					};

					return connection;
				}
			);
		});

		return connectionsByLocaleCode;
	}
}
